<template>
  <button class="mainButton btn" :class="btnClass" :style="btnStyle" :disabled="loading ? true : false">
    <i v-if="hasIcon" :class="icon"></i>
    <span :style="loading ? `opacity: 0.5` : ``"> {{ text }}</span>
    <div v-if="loading" class="spinner">
      <div class="bar1"></div>
      <div class="bar2"></div>
      <div class="bar3"></div>
      <div class="bar4"></div>
      <div class="bar5"></div>
      <div class="bar6"></div>
      <div class="bar7"></div>
      <div class="bar8"></div>
    </div>
  </button>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
    },
    hasIcon: {
      type: Boolean,
      default: false,
    },
    imageSrc: {
      type: String,
    },
    btnClass: {
      type: String,
    },
    btnStyle: {
      type: String,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    type: {
      default: '',
      type: String,
    },
    icon: {
      type: String,
      default: 'fa fa-plus',
    },
  },
}
</script>

<style lang="scss" scoped>
.mainButton {
  display: flex;
  align-items: center;
  cursor: pointer;
  position: relative;
  border-radius: 30px;
  padding: 8.5px 20px;
  outline: none;
  background-color: #34c38f;
}
.shadow {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0.1;
}
i {
  margin-left: 8px;
  font-size: 10px;
}
span,
i {
  color: white;
}
span {
  width: 100%;
}
////////// Loading /////
div.spinner {
  position: relative;
  width: 20px;
  height: 20px;
  border-radius: 10px;
}
div.spinner div {
  width: 6%;
  height: 16%;
  background: #fff;
  position: absolute;
  left: 49%;
  top: 43%;
  opacity: 0;
  -webkit-border-radius: 50px;
  -webkit-box-shadow: 0 0 3px rgba(0, 0, 0, 0.2);
  -webkit-animation: fade 1s linear infinite;
}
@-webkit-keyframes fade {
  from {
    opacity: 1;
  }
  to {
    opacity: 0.25;
  }
}
div.spinner div.bar1 {
  -webkit-transform: rotate(0deg) translate(0, -130%);
  -webkit-animation-delay: 0s;
}
div.spinner div.bar2 {
  -webkit-transform: rotate(45deg) translate(0, -130%);
  -webkit-animation-delay: -0.9167s;
}
div.spinner div.bar3 {
  -webkit-transform: rotate(90deg) translate(0, -130%);
  -webkit-animation-delay: -0.833s;
}
div.spinner div.bar4 {
  -webkit-transform: rotate(135deg) translate(0, -130%);
  -webkit-animation-delay: -0.7497s;
}
div.spinner div.bar5 {
  -webkit-transform: rotate(180deg) translate(0, -130%);
  -webkit-animation-delay: -0.667s;
}
div.spinner div.bar6 {
  -webkit-transform: rotate(225deg) translate(0, -130%);
  -webkit-animation-delay: -0.5837s;
}
div.spinner div.bar7 {
  -webkit-transform: rotate(270deg) translate(0, -130%);
  -webkit-animation-delay: -0.5s;
}
div.spinner div.bar8 {
  -webkit-transform: rotate(315deg) translate(0, -130%);
  -webkit-animation-delay: -0.4167s;
}

.fa-file-excel {
  font-size: 18px;
}
</style>
